import React, {Component} from 'react';
import WindowDimensions from "../utils/WindowDimensions";

class NavElement extends Component {

    static defaultProps = {
        elementId: null,
        classes: [],
        label: '',
        labelKey: null,
        status: 'ok',
        expanded: false,
        expandedTag: '',
        webImgSrc: '',
        mobilImgSrc: '',
        activeElement: false,
        linkTo: '',
        children: [],
        functionAfterClick: false,
        modulWarning: false,
    };

    constructor(props) {

        super(props);

        this.state = {
            height: 0,
            width: 0,
            submenuShow: this.props.expanded,
        };

        this.statusCases = {
            'ok': null,
            'warning': null,
            'locked': 'is locked!',
            'expired': 'Permission expired!',
            'shortly': 'Permissions will expire soon.',
            'soon': 'Coming soon.',
        };

    }

    componentDidMount() {

        this.updateWindowDimensions();

        window.addEventListener('resize', this.updateWindowDimensions.bind(this));

    }

    componentWillUnmount() {

        window.removeEventListener('resize', this.updateWindowDimensions);

    }

    updateWindowDimensions() {

        if (window.innerWidth !== this.state.width || window.innerHeight !== this.state.height) {
            this.setState({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }

    }

    onClickHandle() {

        if (this.props.onClick) {
            return this.props.onClick;
        } else if (!this.props.expanded) {
            return (e) => this.navigate(e, this.props.linkTo);
        }

    }

    navigate(event, target) {

        //if (this.props.status === 'ok') {
            if (this.props.handleNavigation) {
                event.preventDefault();

                this.props.handleNavigation(target);
            }
        /*} else {
            alert(this.props.label + ' - ' + this.statusCases[this.props.status]);
        }*/

        return null;

    }

    getChildren() {

        return [].concat(this.props.children).filter(
            (child) => {
                return (child !== '' && child !== null)
            }
        );

    }

    render() {

        let elementId = this.props.elementId;
        let label = (this.props.labelKey && this.props.translate) ? this.props.translate(this.props.labelKey) : this.props.label;
        let showTitle = (this.props.status === 'ok') ? this.props.label : this.props.label + ' - ' + this.statusCases[this.props.status];
        let expandedTag = this.props.expandedTag;
        let webImgSrc = this.props.webImgSrc;
        let mobilImgSrc = this.props.mobilImgSrc;
        let children = this.getChildren();
        let isActivePage = (this.props.linkTo === this.props.activePage) ? 'activePage' : '';
        let isActive = this.props.activeElement ? 'active' : '';
        let onClickHandle = this.onClickHandle();

        let modulWarningClass = (this.props.modulWarning) ? 'hasModulWarning' : '';
        let hasSubmenu = (children.length > 0) ? 'hasSubmenu' : '';
        let navClasses = ["navElement", this.props.status, modulWarningClass, hasSubmenu, this.props.classes, isActive, isActivePage].join(' ').trim();
        let subClasses = ["subnavi", (this.props.expanded) ? 'active' : ''].join(' ').trim();
        let warningClasses = (children.length > 0) ? 'modulWarning' : 'navWarning';

        //let subNaviHeight = isActive ? (((this.state.width > WindowDimensions.getMaxMobilWidth()) ? 104 : 109) * children.length) : 0;    //  Werte in %.
        let subNaviHeight = isActive ? (((this.state.width > WindowDimensions.getMaxMobilWidth()) ? 111 : 61) * children.length) : 0;       //  Werte in px.

        return (
            <li id={elementId} className={navClasses} onClick={onClickHandle} title={showTitle}>
                <a className="link-web">
                    <img className="img-web" src={webImgSrc} alt={label}/>
                </a>

                <a className="link-mobile">
                    <img className="img-mobile" src={mobilImgSrc} alt={label}/>
                </a>

                <p>{label}</p>

                <a className={warningClasses}> </a>

                <ul id={expandedTag} className={subClasses} style={{height: subNaviHeight + 'px'}}>
                    {children}
                </ul>
            </li>
        );

    }

}

export default NavElement;